import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';
import Divider$1 from '../../../../../node_modules/@mui/material/Divider/Divider.mjs';

const Divider = styled(Divider$1)(({ theme })=>({
        borderColor: theme.styleConfig.colors.subtle
    }));

export { Divider };
//# sourceMappingURL=Divider.mjs.map
